var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEstudoEstrategico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FB002A74-187D-460D-887E-EEC1358447CB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.1-home-aba/carreira-juridica",
    transform: "translate(-24.000000, -574.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-principal",
    transform: "translate(24.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-estudo-estrategico",
    transform: "translate(0.000000, 342.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "001-strategy",
    transform: "translate(0.500000, 1.000000)",
    fill: "#1717CE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,0 C2.29441653,0 0.5,1.79441653 0.5,4 C0.5,6.20558347 2.29441653,8 4.5,8 C6.70558347,8 8.5,6.20558347 8.5,4 C8.5,1.79441653 6.70558347,0 4.5,0 Z M4.5,6.28565845 C3.23966947,6.28565845 2.21428571,5.26031507 2.21428571,3.99994417 C2.21428571,2.73957326 3.23966947,1.71422988 4.5,1.71422988 C5.76033053,1.71422988 6.78571429,2.73961364 6.78571429,3.99994417 C6.78571429,5.26027469 5.76033053,6.28565845 4.5,6.28565845 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6224236,17.5000367 L22.1645182,15.9563061 C22.6118273,15.5085055 22.6118273,14.7799037 22.1645182,14.3321031 C21.7223176,13.889299 20.9842401,13.889299 20.5420395,14.3321031 L19,15.8758337 L17.4579678,14.3321031 C17.0157672,13.889299 16.2776897,13.889299 15.8354891,14.3321031 C15.3881801,14.7799037 15.3881801,15.5085055 15.8354891,15.9563061 L17.3775837,17.5000367 L15.8354891,19.0437673 C15.3881801,19.4915679 15.3881801,20.2201698 15.8354304,20.6679116 C16.2775723,21.1106569 17.0158259,21.1107157 17.4579678,20.6679704 L19,19.1242398 L20.5419808,20.6679116 C20.9841227,21.1106569 21.7223764,21.1107157 22.1645182,20.6679704 C22.6118273,20.2201698 22.6118273,19.4915679 22.1645182,19.0437673 L20.6224236,17.5000367 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1060505,5.41769026 C15.9181223,5.75560964 15.993885,6.18959986 16.3041014,6.44160905 L16.4043928,6.522761 L13.0642008,6.52309115 C11.7865062,6.52309115 10.7526125,7.57257926 10.7526125,8.85766689 L10.7526125,12.6653768 C10.7526125,13.0598726 10.4402506,13.3769404 10.063272,13.3769404 L3.31114728,13.3769404 C2.86050133,13.3769404 2.5,13.7428729 2.5,14.1884702 C2.5,14.6340675 2.86050133,15 3.31114728,15 L10.063272,15 C11.3409667,15 12.3748603,13.9505119 12.3748603,12.6654243 L12.3748603,8.8577144 L12.3839826,8.74192346 C12.4379738,8.40296013 12.7248951,8.14615076 13.0642008,8.14615076 L16.4043928,8.14548181 L16.3041292,8.22761974 C15.9885307,8.48394583 15.9121612,8.94066067 16.1258664,9.28521376 C16.3813784,9.69708893 16.9483865,9.79491449 17.3265782,9.487803 L19.2021561,7.96470691 C19.5992603,7.64221568 19.5992603,7.02729152 19.2022822,6.70468494 L17.3265815,5.18148906 C16.9749427,4.89582976 16.458307,4.95409854 16.1784997,5.30899006 L16.1060505,5.41769026 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstudoEstrategico);
export default __webpack_public_path__ + "static/media/ic-estudo-estrategico.df505910330038c56920d87a22332946.svg";
export { ForwardRef as ReactComponent };